import styled from "styled-components"
import { Steps as AntSteps } from "antd"

export const Steps = styled(AntSteps)`
  .ant-steps-vertical {
    margin-left: 100px !important;
    background: red;
  }
  .ant-steps .ant-steps-vertical .sc-cxpSdN .fQogqr .ant-steps-dot {
    background: red !important;
  }
`
